// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertToValidDate = (input: any) => {
  if (typeof input === 'string') {
    const date = new Date(input);
    if (!isNaN(date.getTime())) {
      return date; // Valid date string, return as Date object
    }
  } else if (input instanceof Date) {
    return input; // Already a Date object, no need for conversion
  }

  return null; // Invalid input, or the conversion failed
};
